(function () {
  var TOTAL_STEPS = 5;
  var current = 1;
  // Passos ativos neste produto (ids lógicos: 1 fundo, 2 telemóvel, 3 pet, 4 extras, 5 review)
  var steps = ['1', '2', '3', '4', '5'];

  var counterEl = document.getElementById('petraitCounter');
  var trackFillEl = document.getElementById('petraitTrackFill');
  var backBtn = document.getElementById('petraitBackBtn');
  var nextBtn = document.getElementById('petraitNextBtn');
  var errorEl = document.getElementById('petraitError');

  var found = { '2': false, '3': false, '4': false };
  // Modo "dividido" (ex.: print): passo 1 só o fundo; passo 2 = layout (Tepo) + tamanho + formato.
  // Ativa-se quando existe um grupo da Tepo com a classe petrait-group-layout.
  var split = false;
  var strayObserverSet = false;

  function forceOpen(group) {
    var content = group.querySelector('.tcustomizer-accordion__content');
    if (!content) return;

    function ensureOpen() {
      if (content.style.maxHeight !== 'none') {
        content.style.setProperty('max-height', 'none', 'important');
        content.style.setProperty('overflow', 'visible', 'important');
      }
      if (content.style.opacity !== '1') {
        content.style.setProperty('opacity', '1', 'important');
      }
    }

    ensureOpen();
    var observer = new MutationObserver(ensureOpen);
    observer.observe(content, { attributes: true, attributeFilter: ['style'] });
  }

  // Força a margem nativa do bloco @app do Shopify a zero, porque o CSS
  // não estava a conseguir vencer a regra do tema para este elemento
  function fixAppBlockMargin() {
    var form = document.querySelector('.tcustomizer-customization-form');
    if (!form) return;
    var el = form;
    while (el && el !== document.body) {
      if (el.classList && (el.classList.contains('product__block--@app') || el.classList.contains('tcustomizer-widget'))) {
        el.style.setProperty('margin', '0', 'important');
      }
      el = el.parentElement;
    }
  }

  // Transforma o botão "Add to cart" da barra sticky em "Next →" e acrescenta a seta de voltar
function setupStickyNext() {
  var btn = document.querySelector('.tcustomizer-overlap-sticky-atc-button');
  if (!btn) return;

  var span = btn.querySelector('span');
  if (span) {
    span.textContent = current === TOTAL_STEPS ? 'Add to cart' : 'Next →';
  }

  if (btn.dataset.petraitBound) return;
  btn.dataset.petraitBound = '1';

  btn.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    nextBtn.click();
  });

  var back = document.createElement('button');
  back.type = 'button';
  back.className = 'petrait-sticky-back';
  back.innerHTML = '←';
  back.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    backBtn.click();
  });

  var priceEl = document.querySelector('.sticky-atc-bar__product-info .f-price-item--sale');
  var priceText = priceEl ? priceEl.textContent.trim() : '';

  var subtotal = document.createElement('div');
  subtotal.className = 'petrait-sticky-subtotal';
  subtotal.textContent = 'Subtotal: ' + priceText;

  var shipText = document.createElement('div');
  shipText.className = 'petrait-sticky-shipping';
  shipText.innerHTML = '<b>FREE</b> shipping over <i>$100</i>';

  btn.parentNode.insertBefore(subtotal, btn);
  btn.parentNode.insertBefore(shipText, btn);
  btn.parentNode.insertBefore(back, btn);
}

function setupStickyVisibility() {
  var stickyEl = document.querySelector('sticky-atc-bar');
  var wrapperEl = stickyEl ? (stickyEl.closest('[id^="shopify-section-sticky-atc-bar"]') || stickyEl.parentElement) : null;
  if (!wrapperEl || wrapperEl.dataset.petraitVisObserved) return;
  wrapperEl.dataset.petraitVisObserved = '1';

  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      wrapperEl.classList.toggle('petrait-sticky-show', !entry.isIntersecting);
    });
  }, { threshold: 0 });
  obs.observe(nextBtn);
}

  // Move campos "soltos" (fora de qualquer grupo) para dentro do grupo "About your pet"
   function fixStrayFields() {
    var group2Wrapper = document.querySelector('.petrait-group-2');
    var form = document.querySelector('.tcustomizer-customization-form');
    if (!group2Wrapper || !form) return;
    var content = group2Wrapper.querySelector('.tcustomizer-accordion__content');
    if (!content) return;

    Array.prototype.slice.call(form.children).forEach(function (el) {
      if (el.classList && el.classList.contains('tcustomizer-group-option')) return;
      if (el.id === 'petraitTail') return;
      if (el.classList && el.classList.contains('tcustomizer-price-addons')) return;
      if (el.tagName === 'SCRIPT') return;
      // Não mexer no campo "Accessory details" — mover isto confunde o
      // Vue da Tepo e cria uma cópia nova a cada clique.
      if (el.classList && el.classList.contains('tcustomizer-field--Text') && el.classList.contains('tcustomizer-width--100')) return;
      content.appendChild(el);
    });
  }

  // Mostra apenas tantas caixas "Accessory details" quantas as pets com
  // "Add accessory" selecionado — sem mover os elementos de posição
  // (mover estes campos confunde o Vue da Tepo e faz com que ele crie
  // caixas novas a cada clique)
    function syncAccessoryDetails() {
    var toggles = document.querySelectorAll('.petrait-group-2 .tp-accessory-toggle');
    var extras = document.querySelectorAll('.petrait-group-2 .tcustomizer-field--Text.tcustomizer-width--100');

    // Remove campos a mais (nunca deve haver mais "Accessory details" do que pets)
    Array.prototype.slice.call(extras).forEach(function (extra, i) {
      if (i >= toggles.length) {
        extra.remove();
      }
    });

    extras = document.querySelectorAll('.petrait-group-2 .tcustomizer-field--Text.tcustomizer-width--100');

    var wantShow = 0;
    toggles.forEach(function (toggle) {
      var addRadio = toggle.querySelector('input[value="Add accessory"]');
      if (addRadio && addRadio.checked) wantShow++;
    });

    extras.forEach(function (extra, i) {
      extra.style.display = i < wantShow ? '' : 'none';
    });
  }

  // Fica a vigiar o formulário para sempre, porque estes campos só aparecem
  // mais tarde (quando se muda o número de pets ou se liga "Add accessory")
  function setupStrayFieldsObserver() {
    if (strayObserverSet) return;
    var form = document.querySelector('.tcustomizer-customization-form');
    var group2Wrapper = document.querySelector('.petrait-group-2');
    if (!form || !group2Wrapper) return;

    strayObserverSet = true;
    fixStrayFields();
    syncAccessoryDetails();

    var observer = new MutationObserver(function () {
      syncAccessoryDetails();
    });
    observer.observe(form, { childList: true });

    form.addEventListener('change', function (e) {
      if (e.target.closest('.tp-accessory-toggle')) {
        syncAccessoryDetails();
      }
    });
  }

  // O grupo do telemóvel (petrait-group-1) é opcional: só existe na capa de telemóvel.
  // O produto é multistep quando existem pelo menos os grupos do pet (2) e dos extras (3).
  function findTepoGroups() {
    var map = { 'petrait-group-1': '2', 'petrait-group-layout': '2', 'petrait-group-2': '3', 'petrait-group-3': '4' };
    var lastGroup = null;

    Object.keys(map).forEach(function (groupClass) {
      var wrapper = document.querySelector('.' + groupClass);
      if (!wrapper) return;
      var group = wrapper.querySelector('.tcustomizer-accordion');
      if (!group || group.hasAttribute('data-step')) return;

      var stepNumber = map[groupClass];
      group.classList.add('petrait-ms-step');
      group.setAttribute('data-step', stepNumber);
      forceOpen(group);
      found[stepNumber] = true;
      if (stepNumber === '4') lastGroup = group;
    });

    setupStrayFieldsObserver();
    fixAppBlockMargin();

    if (found['3'] && found['4'] && lastGroup) {
      var tail = document.getElementById('petraitTail');
      if (tail) {
        lastGroup.insertAdjacentElement('afterend', tail);
        tail.style.display = 'block';
      }
    }
    return found['3'] && found['4'];
  }

  // Define os passos deste produto, conforme os grupos encontrados
  function finalizeSteps() {
    split = !!document.querySelector('.petrait-group-layout');
    if (split) {
      STEP_LABELS['1'] = 'Background';
      STEP_LABELS['2'] = 'Layout';
    }
    steps = ['1'];
    if (found['2']) steps.push('2');
    steps.push('3', '4', '5');
    TOTAL_STEPS = steps.length;
  }

  function getText(sel) {
    var el = document.querySelector(sel);
    return el ? el.textContent.trim() : '';
  }

  // Todos os campos de upload (um por pet)
  function getUploadFields() {
    return document.querySelectorAll('.petrait-group-2 .tcustomizer-field--FileUpload');
  }

  // Todos os campos de nome (um por pet)
  function getNameInputs() {
    return document.querySelectorAll('.petrait-group-2 .tp-pet-name input');
  }

  function updateReview() {
    var bg = getText('[data-selected-swatch-value="Color"]');

    var brand = getText('.petrait-group-1 .tp-brand .tcustomizer-btn--active .tcustomizer-radio-button__label-content span:first-child');
    var model = getText('.petrait-group-1 .tp-model-dropdown .tcustomizer__dropdown-button span');
    var magsafe = getText('.petrait-group-1 .tp-magsafe-btn .tcustomizer-btn--active .tcustomizer-radio-button__label-content span:first-child');
    var phone = [brand, model].filter(Boolean).join(' ');
    if (magsafe && magsafe.indexOf('Standard') === -1) phone += ' + ' + magsafe;

    var petCount = getText('.petrait-group-2 .tp-pet-count .tcustomizer-btn--active .tcustomizer-radio-button__label-content span:first-child');
    var names = [];
    getNameInputs().forEach(function (input) {
      var v = input.value.trim();
      if (v) names.push(v);
    });
    var pet = [petCount, names.join(', ')].filter(Boolean).join(' — ');

    var extrasChecked = document.querySelectorAll('.petrait-group-3 .tp-extras input[type="checkbox"]:checked');
    var extrasNames = [];
    extrasChecked.forEach(function (cb) {
      var label = cb.nextElementSibling;
      var span = label ? label.querySelector('.tcustomizer-radio-button__label-content span:first-child') : null;
      if (span) extrasNames.push(span.textContent.trim());
    });

    document.getElementById('reviewBg').textContent = bg || '—';
    document.getElementById('reviewPhone').textContent = phone || '—';
    document.getElementById('reviewPet').textContent = pet || '—';
    document.getElementById('reviewExtras').textContent = extrasNames.length ? extrasNames.join(', ') : 'None';

    // Modo dividido (print): a linha do telemóvel passa a mostrar layout · tamanho · formato
    if (split) {
      var layoutBtn = document.querySelector('.petrait-group-layout .tcustomizer-btn--active .tcustomizer-radio-button__label-content span:first-child');
      var layoutInput = document.querySelector('.petrait-group-layout input:checked');
      var layout = layoutBtn ? layoutBtn.textContent.trim() : (layoutInput ? layoutInput.value : '');
      var printInfo = [layout, getText('[data-selected-swatch-value="Size"]'), getText('[data-selected-swatch-value="Format"]')].filter(Boolean).join(' · ');
      var rowEl = document.getElementById('reviewPhone');
      if (rowEl) {
        rowEl.textContent = printInfo || '—';
        var labelEl = rowEl.parentElement ? rowEl.parentElement.firstElementChild : null;
        var hasPrintOpts = !!document.querySelector('[data-selected-swatch-value="Size"], [data-selected-swatch-value="Format"]');
        if (labelEl && labelEl !== rowEl) labelEl.textContent = hasPrintOpts ? 'Print' : 'Layout';
      }
    }

    // Nos produtos sem passo de telemóvel, esconde essa linha da review
    var phoneEl = document.getElementById('reviewPhone');
    if (phoneEl && phoneEl.parentElement) {
      phoneEl.parentElement.style.display = found['2'] ? '' : 'none';
    }
  }

    function highlightInvalidFields() {
    getUploadFields().forEach(function (field) {
      var hasPhoto = field.querySelector('.tcustomizer-file-item') !== null;
      field.classList.toggle('petrait-field-invalid', !hasPhoto);
    });

    getNameInputs().forEach(function (input) {
      var wrapper = input.closest('.tcustomizer-field__input') || input;
      var hasName = input.value.trim() !== '';
      wrapper.classList.toggle('petrait-field-invalid', !hasName);
    });
  }

  function clearInvalidFields() {
    document.querySelectorAll('.petrait-field-invalid').forEach(function (el) {
      el.classList.remove('petrait-field-invalid');
    });
  }

  // ===== Nova barra de progresso (segmentos + nome de cada passo) =====
  // Construída por JS a partir da barra antiga: esconde o "1/5" e a linha
  // antigos e põe a nova no mesmo sítio. Fica fora do formulário da Tepo.
  var STEP_LABELS = { '1': 'Design', '2': 'Phone', '3': 'Pet', '4': 'Extras', '5': 'Review' };
  var progressEl = null;

  function topChildContaining(wrap, el) {
    while (el && el.parentElement !== wrap) el = el.parentElement;
    return el;
  }

  function buildProgress() {
    if (!counterEl || !trackFillEl) return null;
    var wrap = counterEl.parentElement;
    while (wrap && !wrap.contains(trackFillEl)) wrap = wrap.parentElement;
    if (!wrap) return null;
    var a = topChildContaining(wrap, counterEl);
    var b = topChildContaining(wrap, trackFillEl);
    if (!a || !b) return null;
    var el = document.createElement('div');
    el.className = 'petrait-progress';
    el.setAttribute('aria-label', 'Customization progress');
    var first = (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING) ? a : b;
    wrap.insertBefore(el, first);
    a.style.setProperty('display', 'none', 'important');
    b.style.setProperty('display', 'none', 'important');
    return el;
  }

  function renderProgress(n) {
    if (!progressEl) progressEl = buildProgress();
    if (!progressEl) return;
    var key = steps.join(',');
    if (progressEl.getAttribute('data-steps') !== key) {
      var html = '<div class="petrait-progress__top">Step <strong data-pp-current></strong> of <span data-pp-total></span></div>' +
        '<ol class="petrait-progress__steps" style="grid-template-columns: repeat(' + steps.length + ', minmax(0, 1fr));">';
      steps.forEach(function (id) {
        html += '<li class="petrait-progress__step"><span class="petrait-progress__seg"></span>' +
          '<span class="petrait-progress__label">' + (STEP_LABELS[id] || '') + '</span></li>';
      });
      html += '</ol>';
      progressEl.innerHTML = html;
      progressEl.setAttribute('data-steps', key);
    }
    progressEl.querySelector('[data-pp-current]').textContent = n;
    progressEl.querySelector('[data-pp-total]').textContent = TOTAL_STEPS;
    progressEl.querySelectorAll('.petrait-progress__step').forEach(function (li, i) {
      li.classList.toggle('is-done', i < n - 1);
      li.classList.toggle('is-current', i === n - 1);
      if (i === n - 1) li.setAttribute('aria-current', 'step');
      else li.removeAttribute('aria-current');
    });
  }

  // n = posição do passo (1 a TOTAL_STEPS); o id lógico vem de steps[n - 1]
   function showStep(n) {
    var id = steps[n - 1];
    errorEl.classList.remove('visible');
    document.querySelectorAll('.petrait-ms-step').forEach(function (el) {
      el.classList.toggle('active', el.getAttribute('data-step') === id);
    });
    counterEl.textContent = n + '/' + TOTAL_STEPS;
    trackFillEl.style.width = (n / TOTAL_STEPS * 100) + '%';
    renderProgress(n);
    backBtn.style.setProperty('display', n === 1 ? 'none' : 'flex', 'important');
    nextBtn.innerHTML = n === TOTAL_STEPS ? 'Add to cart' : 'Next <span class="petrait-ms-next-arrow">→</span>';
    var root = document.documentElement;
    root.classList.toggle('petrait-split', split);
    root.classList.toggle('petrait-at-1', id === '1');
    root.classList.toggle('petrait-at-2', id === '2');
    if (id === '5') updateReview();
  }

  // Valida TODOS os pets, não só o primeiro (recebe o id lógico do passo)
   function stepIsValid(id) {
    if (id === '2' && split) {
      return !!document.querySelector('.petrait-group-layout input:checked, .petrait-group-layout .tcustomizer-btn--active');
    }
    if (id === '2') {
      var model = getText('.petrait-group-1 .tp-model-dropdown .tcustomizer__dropdown-button span');
      return !!model && model.toLowerCase() !== 'select an option';
    }

    if (id !== '3') return true;

    var uploadFields = getUploadFields();
    var allPhotos = uploadFields.length > 0 && Array.prototype.every.call(uploadFields, function (field) {
      return field.querySelector('.tcustomizer-file-item') !== null;
    });

    var nameInputs = getNameInputs();
    var allNames = nameInputs.length === 0 || Array.prototype.every.call(nameInputs, function (input) {
      return input.value.trim() !== '';
    });

    return allPhotos && allNames;
  }

   nextBtn.addEventListener('click', function () {
    var id = steps[current - 1];
    if (!stepIsValid(id)) {
      if (id === '2' && split) {
        errorEl.innerHTML = 'Please choose your <b>layout</b> to continue.';
      } else if (id === '2') {
        errorEl.innerHTML = 'Please select your <b>phone model</b> to continue.';
      } else if (id === '3') {
        errorEl.innerHTML = 'Please upload a <b>photo</b> and enter a <b>pet name</b> to continue.';
      }
      errorEl.classList.add('visible');
      return;
    }
    errorEl.classList.remove('visible');

    if (current < TOTAL_STEPS) {
      current++;
      showStep(current);
    } else {
      var realAddToCart = document.querySelector('.product__block--buy_buttons button[type="submit"]');
      if (realAddToCart) {
        realAddToCart.click();
      }
    }
  });

  backBtn.addEventListener('click', function () {
    if (current > 1) {
      current--;
      showStep(current);
    }
  });

  // data-goto guarda o id lógico do passo (1 a 4); converte para a posição real
  document.querySelectorAll('.petrait-ms-edit').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var pos = steps.indexOf(btn.getAttribute('data-goto')) + 1;
      current = pos > 0 ? pos : 1;
      showStep(current);
    });
  });

  // Produtos digitais (nenhuma variante precisa de envio): troca a etiqueta de portes
  // e o texto "Preview Before Shipping" por versões de entrega digital.
  function applyDigital() {
    document.documentElement.classList.add('petrait-digital');
    var ship = document.querySelector('.petrait-ms-ship-row');
    if (ship) ship.innerHTML = '<b>Digital file</b> · delivered by email, no shipping needed';
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = walker.nextNode())) {
      if (/Preview Before Shipping/i.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(/Before Shipping/i, 'Before Delivery');
    }
  }
  (function detectDigital() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m) return;
    fetch('/products/' + m[1] + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var v = p && p.variants ? p.variants : [];
      if (v.length && v.every(function (x) { return x.requires_shipping === false; })) applyDigital();
    }).catch(function () {});
  })();

  var tries = 0;
  var readyTicks = 0;
  var poll = setInterval(function () {
    tries++;
    var ok = findTepoGroups();
    var root = document.documentElement;
    if (ok) {
      // espera mais um ciclo para dar tempo ao grupo do telemóvel, se existir
      readyTicks++;
      if (readyTicks >= 2) {
        clearInterval(poll);
        finalizeSteps();
        root.classList.remove('petrait-ms-off');
        showStep(1);
      }
    } else if (tries > 40) {
      clearInterval(poll);
      showStep(1);
    } else if (tries >= 12) {
      // ~3s sem encontrar os grupos = não é um produto multistep: mostra o Add to cart original
      root.classList.add('petrait-ms-off');
    }
  }, 250);

    function cleanCartItemOptions() {
    document.querySelectorAll('.cart-item__options').forEach(function (container) {
      var rows = Array.prototype.slice.call(container.children);

      var groups = {
        background: [], phone: [], magsafe: [], petcount: [],
        petname: [], extras: [], text: [], editbtn: [], other: []
      };

      rows.forEach(function (row) {
        var dt = row.querySelector('dt');
        var label = dt ? dt.textContent.trim().toLowerCase() : '';
        var hasFileLink = row.querySelector('a[href*="cdn.tepo.app"]') !== null;

        if (hasFileLink || label.startsWith('pet ') || label.indexOf('upload') !== -1) {
          row.style.display = 'none';
          groups.other.push(row);
        } else if (row.classList.contains('cart-item__option-value')) {
          groups.background.push(row);
        } else if (label.indexOf('phone brand') !== -1 || label.indexOf('model') !== -1) {
          groups.phone.push(row);
        } else if (label.indexOf('magsafe') !== -1) {
          groups.magsafe.push(row);
        } else if (label.indexOf('how many pets') !== -1) {
          groups.petcount.push(row);
        } else if (label.startsWith('name')) {
          groups.petname.push(row);
        } else if (label.indexOf('accessory') !== -1) {
          groups.extras.push(row);
        } else if (label.indexOf('add your text') !== -1) {
          groups.text.push(row);
        } else if (row.classList.contains('product-option')) {
          groups.editbtn.push(row);
        } else {
          groups.other.push(row);
        }
      });

      var ordered = [].concat(
        groups.background, groups.phone, groups.magsafe, groups.petcount,
        groups.petname, groups.extras, groups.text, groups.other, groups.editbtn
      );
      // Só mexe na ordem se for diferente (evita alterações inúteis no DOM)
      var same = ordered.every(function (row, i) { return container.children[i] === row; });
      if (!same) ordered.forEach(function (row) { container.appendChild(row); });
    });
  }

    // Antes corria de 0,5 em 0,5 s para sempre; agora só quando o carrinho muda
    var cartQueued = false;
    function queueCartClean() {
      if (cartQueued) return;
      cartQueued = true;
      requestAnimationFrame(function () { cartQueued = false; cleanCartItemOptions(); });
    }
    cleanCartItemOptions();
    var cartRoots = [document.querySelector('cart-drawer')];
    if (/^\/cart/.test(location.pathname)) cartRoots.push(document.getElementById('MainContent'));
    cartRoots.forEach(function (rootEl) {
      if (rootEl) new MutationObserver(queueCartClean).observe(rootEl, { childList: true, subtree: true });
    });

/*
setInterval(function () {
  setupStickyNext();
  setupStickyVisibility();
}, 500);
*/
})();

// ===== Badge "Save X%" ao lado do preço =====
// Esconde o badge original (continua a servir de fonte, porque o tema
// atualiza-o quando a variante muda) e mostra uma cópia a seguir ao preço riscado.
(function () {
  var RE = /^\s*save\s*[\d.,]+\s*%\s*$/i;
  var src = null;
  var queued = false;
  // Só procura e vigia a zona do produto (antes era a página inteira)
  var SCOPE = null;
  function scopeEl() {
    if (!SCOPE || !document.body.contains(SCOPE)) {
      SCOPE = document.querySelector('.product__info-wrapper') || document.querySelector('product-info');
    }
    return SCOPE;
  }

  function isShown(el) { return !!el && el.getClientRects().length > 0; }

  // Procura o texto "Save" e sobe até ao elemento cujo texto completo é "Save 10%"
  // (funciona mesmo quando o texto está partido em vários elementos)
  function findSaveSource() {
    var root = scopeEl();
    if (!root) return null;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        return /save/i.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
    var n;
    while ((n = walker.nextNode())) {
      var el = n.parentElement;
      while (el && el !== document.body && !RE.test(el.textContent) && el.textContent.length < 40) {
        el = el.parentElement;
      }
      if (!el || el === document.body || !RE.test(el.textContent)) continue;
      if (el.closest('.petrait-save-inline, script, style, noscript')) continue;
      while (el.parentElement && el.parentElement !== document.body && RE.test(el.parentElement.textContent)) {
        el = el.parentElement;
      }
      return el;
    }
    return null;
  }

  function isVisiblePrice(el) {
    if (!el || !/\d/.test(el.textContent)) return false;
    if (el.closest('.petrait-save-src, sticky-atc-bar, [hidden]')) return false;
    var r = el.getBoundingClientRect();
    return r.width > 2 && r.height > 2;
  }

  // Preço riscado VISÍVEL mais próximo do badge, na vertical.
  // No Sleek o preço riscado é ".f-price-item--regular" (não usa <s>/<del>),
  // e há outros preços na página (produtos recomendados), por isso escolhe-se
  // o que está mais perto do badge original.
  function findCompare(from) {
    var top = from.getBoundingClientRect().top;
    var cands = document.querySelectorAll('.f-price-item--regular, s, del');
    var best = null, bestD = Infinity;
    for (var i = 0; i < cands.length; i++) {
      var c = cands[i].closest('.f-price-item--regular') || cands[i];
      if (from.contains(c) || c.querySelector('.petrait-save-inline')) continue;
      if (!isVisiblePrice(c)) continue;
      var d = Math.abs(c.getBoundingClientRect().top - top);
      if (d < bestD) { best = c; bestD = d; }
    }
    return bestD < 600 ? best : null;
  }

  function sync() {
    if (!src || !document.body.contains(src)) src = findSaveSource();
    var badge = document.querySelector('.petrait-save-inline');
    if (!src) { if (badge) badge.remove(); return; }

    // Avalia com o badge original visível, para não o confundir com "sem desconto"
    src.classList.remove('petrait-save-src');
    var cmp = isShown(src) ? findCompare(src) : null;
    if (!cmp) {
      // Não há sítio para o pôr: deixa o badge original visível no sítio normal
      if (badge) badge.remove();
      return;
    }
    src.classList.add('petrait-save-src');
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'petrait-save-inline';
    }
    if (badge.previousElementSibling !== cmp) cmp.insertAdjacentElement('afterend', badge);
    var t = src.textContent.replace(/\s+/g, ' ').trim();
    if (badge.textContent !== t) badge.textContent = t;
  }

  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; sync(); });
  }

  function init() {
    var root = scopeEl();
    if (!root) return; // não é página de produto
    sync();
    new MutationObserver(queue).observe(root, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

// ===== Vídeo da galeria (VIM) só carrega quando aparece no ecrã =====
// O vídeo da galeria tem autoplay e descarregava ~4 MB logo à entrada, a competir
// com a foto principal (LCP). Enquanto o slide do vídeo não está visível, tiramos-lhe
// o ficheiro (fica o poster) e repomos quando o cliente chega a esse slide.
(function () {
  function isVisible(el) {
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && r.bottom > 0 && r.right > 0 &&
      r.left < (window.innerWidth || 0) && r.top < (window.innerHeight || 0);
  }

  function setup() {
    if (!('IntersectionObserver' in window)) return;
    document.querySelectorAll('video.VIM-slide-video').forEach(function (v) {
      // Sem verificar se está visível: se estiver, o IntersectionObserver repõe-no logo a seguir
      if (v.dataset.petraitLazy) return;
      var sources = Array.prototype.slice.call(v.querySelectorAll('source[src]'));
      if (!sources.length) return;
      v.dataset.petraitLazy = '1';
      sources.forEach(function (s) { s.dataset.src = s.getAttribute('src'); s.removeAttribute('src'); });
      v.removeAttribute('autoplay');
      v.autoplay = false;
      try { v.pause(); v.load(); } catch (e) {}

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          io.disconnect();
          sources.forEach(function (s) { s.setAttribute('src', s.dataset.src); });
          v.autoplay = true;
          v.setAttribute('autoplay', 'autoplay');
          try {
            v.load();
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } catch (e) {}
        });
      }, { threshold: 0.3 });
      io.observe(v);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
  // A app VIM volta a desenhar a galeria depois de carregar: apanha os vídeos novos logo que entram
  var vimQueued = false;
  var mainEl = document.getElementById('MainContent') || document.body;
  new MutationObserver(function (muts) {
    if (vimQueued) return;
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType === 1 && (n.matches('video.VIM-slide-video') || n.querySelector('video.VIM-slide-video'))) {
          vimQueued = true;
          Promise.resolve().then(function () { vimQueued = false; setup(); });
          return;
        }
      }
    }
  }).observe(mainEl, { childList: true, subtree: true });
})();
